import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import esfOptions from '@/utils/format-edit/rirekishoEsfOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoEsfDetailCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useRirekishoFormatData()
const shogaiKindOptions = ref(esfOptions.shogaiKindOptionTemps.first)
const shogaiLevelOptions = ref(esfOptions.shogaiLevelOptionTemps.first)
const disorderFeatureVisible = ref(false)
const selfDisorderFeatureVisible = ref(false)
const considerationDesiredVisible = ref(false)

function selectHandbookKind() {
  if (formatData.handbookKind === '身体障害者手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.first
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.first
  }
  if (formatData.handbookKind === '療育手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.second
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.second
  }
  if (formatData.handbookKind === '精神障害者保健福祉手帳') {
    shogaiKindOptions.value = esfOptions.shogaiKindOptionTemps.third
    shogaiLevelOptions.value = esfOptions.shogaiLevelOptionTemps.third
  }
  formatData.shogaiKind = ''
  formatData.shogaiLevel = ''
}

return { __sfc: true,formatData, shogaiKindOptions, shogaiLevelOptions, disorderFeatureVisible, selfDisorderFeatureVisible, considerationDesiredVisible, selectHandbookKind, NewRirekishoExampleSentenceDialog, esfOptions }
}

})